module.exports = __webpack_public_path__ + "img/rule-title-pic.1d931938.png";